<template>
    <div class="page-header-title">
        <text-loading-placeholder
            v-if="loading"
            class="w-50 h3"
            :style="{
                minWidth: '50%'
            }"
            tag="h3"
        />
        <template v-else>
            <template v-if="!editState">
                <component
                        :is="titleTag"
                        class="initial-value text-truncate"
                        :class="{'d-block d-md-none': !editable}"
                >
                    {{ initialValue }}
                </component>

                <i
                        v-if="showLock && !editable"
                        class="lock-icon fas fa-lock my-auto ml-2 pb-1"
                />
            </template>
            <template
                v-else
            >
                <b-input
                    :value="internalModel"
                    @input="handleInput"
                    class="edit-input d-inline w-50"
                />
                <b-button
                    class="link-button save p-0"
                    variant="link"
                    @click="handleSave"
                >
                    save
                </b-button>
            </template>
            <b-button
                v-if="editable"
                class="link-button p-0"
                variant="link"
                @click="toggleEditState"
                :class="btnText"
            >
                {{ btnText }}
            </b-button>
        </template>
    </div>
</template>

<script>
    import './PageHeaderTitle.scss';

    export const RESOURCE_NAME_UPDATED = 'RESOURCE_NAME_UPDATED';

    export default {
        name: "PageHeaderTitleNew",
        props: {
            value: {
                type: String,
                default: ''
            },
            loading: {
                type: Boolean,
                default: false
            },
            editable: {
                type: Boolean,
                default: false
            },
            titleTag: {
                type: String,
                default: 'h1'
            },
            showLock: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                internalModel: this.value,
                initialValue: this.value,
                editState: false
            };
        },
        computed: {
            btnText() {
                return this.editState ? 'cancel' : 'edit';
            }
        },
        methods: {
            toggleEditState() {
                this.internalModel = this.initialValue;
                this.editState = !this.editState;
            },
            handleSave() {
                this.editState = !this.editState;
                this.$emit('input', this.internalModel);
                this.$bus.$emit(RESOURCE_NAME_UPDATED, this.internalModel);
            },
            handleInput(value) {
                // this line trims multiple spaces inside the name
                // in order to avoid saving them later in database
                this.internalModel = value.replace(/  +/g, ' ');
            }
        },
        watch: {
            value(newVal) {
                this.internalModel = newVal;
                this.initialValue = newVal;
            }
        }
    };
</script>
